import { ActionTree, ActionContext } from 'vuex';

import { subsClient } from '@/http-client';
import { camelToSnake, snakeToCamel } from '@/utils';

import { RootStateI } from '../state';
import { PaymentStateI } from './state';

export const actions: ActionTree<PaymentStateI, RootStateI> = {
};
